import { render, staticRenderFns } from "./official-flow.vue?vue&type=template&id=f08bd02c&scoped=true"
import script from "./official-flow.vue?vue&type=script&lang=js"
export * from "./official-flow.vue?vue&type=script&lang=js"
import style0 from "./official-flow.vue?vue&type=style&index=0&id=f08bd02c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f08bd02c",
  null
  
)

export default component.exports